import type { NavigationItem, SubNavigationItem } from '@/composables/routing';
import type { Rollout } from '@/types';
import type { UserRoleValues } from '@/config/user-roles';

export const isNavItemAccessible = (
  item: NavigationItem | SubNavigationItem,
  selectedRollout: Rollout | false,
  userRole?: UserRoleValues
) => {
  const isPermitted =
    !item.permittedRoles ||
    (userRole && item.permittedRoles.includes(userRole));

  const isGlobal = item.global;

  const isRolloutSelected = selectedRollout !== false;
  const isRolloutPermitted =
    isRolloutSelected &&
    (!item.permittedPlan ||
      (selectedRollout as Rollout).plan >= item.permittedPlan);

  return isPermitted && (isGlobal || isRolloutPermitted);
};
